import React, { type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@repo/design-system-kit/components/button/button';
import { LottiePlayer } from '@repo/design-system-kit/components/lottie-player/lottie-player';
import errorLottie from '@repo/visual-assets/dotlottie/lottie_pop_general_error404.lottie';
import styles from './styles.module.css';

interface PricingErrorProps {
  onRetry: () => void;
}

export function PricingError({ onRetry }: PricingErrorProps): ReactNode {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.wrapper} data-test-pricing-error>
      <LottiePlayer
        className={styles.illustration}
        data-test-pricing-error-lottie
        loop
        src={errorLottie}
      />
      <h1 className={styles.title} data-test-pricing-error-title>
        {formatMessage({ id: 'price_plan.choose-plan.error.title' })}
      </h1>
      <p className={styles.description} data-test-pricing-error-description>
        {formatMessage({ id: 'price_plan.choose-plan.error.description' })}
      </p>
      <Button data-test-pricing-error-cta onPress={onRetry} stretch type="button" variant="primary">
        {formatMessage({ id: 'price_plan.choose-plan.error.cta' })}
      </Button>
    </div>
  );
}
